import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Dropdown } from 'wix-rich-content-ui-components';
import { s as styles } from '../../anchor-panel-0570bfc1.js';
import { ANCHORABLE_BLOCKS } from './consts.js';
import FilterDropdownElement from './FilterDropdownElement.js';
import '../../style-inject.es-746bb8ed.js';
import 'wix-rich-content-common';
import '../Icons/AnchorsThumbnails/ParagraphIcon.js';
import '../Icons/AnchorsThumbnails/H1Icon.js';
import '../Icons/AnchorsThumbnails/H2Icon.js';
import '../Icons/AnchorsThumbnails/H3Icon.js';
import '../Icons/AnchorsThumbnails/H4Icon.js';
import '../Icons/AnchorsThumbnails/H5Icon.js';
import '../Icons/AnchorsThumbnails/H6Icon.js';
import '../Icons/AnchorsThumbnails/CodeBlockIcon.js';
import '../Icons/AnchorsThumbnails/BlockQuoteIcon.js';
import '../Icons/AnchorsThumbnails/ImageIcon.js';
import '../Icons/AnchorsThumbnails/GalleryIcon.js';
import '../Icons/AnchorsThumbnails/VideoIcon.js';
import '../Icons/AnchorsThumbnails/MapIcon.js';
import '../Icons/AnchorsThumbnails/ButtonIcon.js';
import '../Icons/AnchorsThumbnails/GiphyIcon.js';
import '../Icons/AnchorsThumbnails/FileIcon.js';

var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class FilterDropdown extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "createFilterDropdownOption", ({ value, label }) => {
      return {
        value,
        component: () => /* @__PURE__ */ React.createElement(FilterDropdownElement, { label })
      };
    });
    __publicField(this, "filterDropdownOptions", (options) => {
      const { t } = this.props;
      const optionsArray = options.map(
        (option) => this.createFilterDropdownOption({
          value: option,
          label: t(ANCHORABLE_BLOCKS[option].filter)
        })
      );
      const allOption = this.createFilterDropdownOption({
        value: "all",
        label: t("LinkTo_Modal_Section_Filter_All")
      });
      return [allOption, ...optionsArray];
    });
  }
  render() {
    const { anchorableBlocksData, filterChanged, filter } = this.props;
    const { pluginsIncluded } = anchorableBlocksData;
    return /* @__PURE__ */ React.createElement("div", { className: styles.AnchorPanel_dropdownWrapper }, /* @__PURE__ */ React.createElement(
      Dropdown,
      {
        value: filter,
        options: this.filterDropdownOptions(pluginsIncluded),
        controlClassName: styles.AnchorPanel_dropdownControl,
        menuClassName: styles.AnchorPanel_dropdownMenu,
        onChange: filterChanged,
        tabIndex: 0
      }
    ));
  }
}
FilterDropdown.propTypes = {
  anchorableBlocksData: PropTypes.array.isRequired,
  t: PropTypes.func.isRequired,
  filterChanged: PropTypes.func,
  filter: PropTypes.object
};

export { FilterDropdown as default };
//# sourceMappingURL=FilterDropdown.js.map
